import { FC, useContext, useEffect } from "react";
import { useLocation } from "react-router";

import { hotjarIdentify } from "@/core/tracking/hotjar";

import { UserContext } from "../User/UserContext";

interface HotJarIdentifierProps {}

export const HotJarIdentifier: FC<HotJarIdentifierProps> = ({}) => {
  const { sessionUser, contextConsultantProfileId } = useContext(UserContext);

  const { pathname } = useLocation();

  useEffect(() => {
    hotjarIdentify({
      userId: sessionUser?.id,
      profileId: contextConsultantProfileId,
    });
  }, [sessionUser, contextConsultantProfileId, pathname]);

  return null;
};
